// extracted by mini-css-extract-plugin
export default {"workingHoursWrapper":"WorkSchedule_workingHoursWrapper__wpjpE"};